<script>
    import FamiliesCollection from '../components/families/FamiliesCollection.vue';

    export default {
      components: { FamiliesCollection },
    };
</script>